import src from "IMAGE";
export default { src, width: 650, height: 600, blurWidth: 0, blurHeight: 0};
